var $boxReadMore = $('.js-box-read-more');
if ($boxReadMore.length) {
  $boxReadMore.on('click', function(event) {
    event.preventDefault();
    $(this).closest('.box').toggleClass('is-box-open');
  });
};
